function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { notifyManager } from './notifyManager.esm.js';
import { Mutation } from './mutation.esm.js';
import { matchMutation, noop } from './utils.esm.js';
import { Subscribable } from './subscribable.esm.js'; // CLASS

var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inherits(MutationCache, _Subscribable);

  var _super = _createSuper(MutationCache);

  function MutationCache(config) {
    var _this;

    _classCallCheck(this, MutationCache);

    _this = _super.call(this);
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  _createClass(MutationCache, [{
    key: "build",
    value: function build(client, options, state) {
      var mutation = new Mutation({
        mutationCache: this,
        logger: client.getLogger(),
        mutationId: ++this.mutationId,
        options: client.defaultMutationOptions(options),
        state: state,
        defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
      });
      this.add(mutation);
      return mutation;
    }
  }, {
    key: "add",
    value: function add(mutation) {
      this.mutations.push(mutation);
      this.notify({
        type: 'added',
        mutation: mutation
      });
    }
  }, {
    key: "remove",
    value: function remove(mutation) {
      this.mutations = this.mutations.filter(function (x) {
        return x !== mutation;
      });
      this.notify({
        type: 'removed',
        mutation: mutation
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      notifyManager.batch(function () {
        _this2.mutations.forEach(function (mutation) {
          _this2.remove(mutation);
        });
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.mutations;
    }
  }, {
    key: "find",
    value: function find(filters) {
      if (typeof filters.exact === 'undefined') {
        filters.exact = true;
      }

      return this.mutations.find(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(filters) {
      return this.mutations.filter(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;

      notifyManager.batch(function () {
        _this3.listeners.forEach(function (_ref) {
          var listener = _ref.listener;
          listener(event);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var _this4 = this;

      var _this$resuming;

      this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(function () {
        var pausedMutations = _this4.mutations.filter(function (x) {
          return x.state.isPaused;
        });

        return notifyManager.batch(function () {
          return pausedMutations.reduce(function (promise, mutation) {
            return promise.then(function () {
              return mutation.continue().catch(noop);
            });
          }, Promise.resolve());
        });
      }).then(function () {
        _this4.resuming = undefined;
      });
      return this.resuming;
    }
  }]);

  return MutationCache;
}(Subscribable);

export { MutationCache };